import React, {
  InputHTMLAttributes, useEffect, useRef, useState, useCallback,
} from 'react';
import { useField } from '@unform/core';

import { FiAlertCircle } from 'react-icons/fi';
import { Container, Error } from './styles';

interface InputProp extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  disabled?: boolean;
}

const Input: React.FC<InputProp> = ({
  name, disabled = false, ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isFocused, setIsFocused] = useState(false);
  const [value, setValue] = useState('');

  const {
    fieldName, defaultValue, error, registerField,
  } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',

      setValue(ref, value) {
        if (typeof value === 'string') {
          let parse = value;
          parse = parse.replace(/\D/g, '');
          parse = parse.replace(/(\d)(\d{1})$/, '$1-$2');
          setValue(parse);
        }
      },

    });
  }, [fieldName, registerField]);

  const handleFocused = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);
  }, []);

  const handleChange = (e: React.FormEvent<HTMLInputElement>):void => {
    e.currentTarget.maxLength = 9;

    let { value } = e.currentTarget;
    value = value.replace(/\D/g, '');
    value = value.replace(/(\d)(\d{1})$/, '$1-$2');
    setValue(value);
  };

  return (
    <Container
      readOnly={disabled}
      isErrored={!!error}
      isFocused={isFocused}
      onBlur={handleInputBlur}
    >
      <input
        ref={inputRef}
        onFocus={handleFocused}
        defaultValue={defaultValue}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        {...rest}

      />

      <Error title={error || ''}>
        <FiAlertCircle color="#c53030" size={20} />
      </Error>

    </Container>
  );
};

export default Input;
